module.exports = __webpack_public_path__ + "img/blu.6ce74a5d.png";